import Swiper from 'swiper';
import 'swiper/css';
import { getElementFromEvent } from '../utils';

export default class LibrarySlider {
	constructor(el) {
		this.el = el;
		this.parent = this.el.closest('[data-slider-parent]');

		if (this.parent) {
			this.prevButton = this.parent.querySelector('[data-prev]');
			this.nextButton = this.parent.querySelector('[data-next]');

			this.parent.addEventListener('click', (e) => {
				const prev = getElementFromEvent(e, '[data-prev]');
				const next = getElementFromEvent(e, '[data-next]');

				if (prev) {
					this.swiper.slidePrev();
				}

				if (next) {
					this.swiper.slideNext();
				}
			});
		}

		this.swiper = new Swiper(this.el, {
			spaceBetween: 10,
			breakpoints: {
				576: {
					spaceBetween: 10,
					slidesPerView: 2,
				},
				768: {
					spaceBetween: 10,
					slidesPerView: 2,
				},
				992: {
					spaceBetween: 10,
					slidesPerView: 4,
				},
				1200: {
					spaceBetween: 10,
					slidesPerView: 4,
				},
			},
		});

		this.swiper.on('fromEdge', (e) => {
			[this.prevButton, this.nextButton].forEach((button) => {
				if (!button) {
					return;
				}

				button.disabled = false;
			});
		});

		this.swiper.on('reachBeginning', (e) => {
			if (!this.prevButton) {
				return;
			}

			this.prevButton.disabled = true;
		});

		this.swiper.on('reachEnd', (e) => {
			if (!this.nextButton) {
				return;
			}

			this.nextButton.disabled = true;
		});
	}

	static init() {
		document.addEventListener('bless', (e) => {
			e.target.querySelectorAll('[data-library-slider]').forEach((el) => new LibrarySlider(el));
		});
	}
}
